// Types
import { CourseTabBar as IProps } from './CourseTabBar.types';

// Styling
import './CourseTabBar.scss';
import { v4 as uuid } from 'uuid';
import { ButtonBase } from 'components/General/ButtonBase/ButtonBase';
import { useLocation, useNavigate } from 'react-router';

export const CourseTabBar = ({ tabs, parentRoute }: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTab = location.pathname.split('/')?.[5];

  const handleTabChange = (tab: string) => {
    navigate(`/${parentRoute}/${tab.split(' ').join('_').toLocaleLowerCase()}`);
  };

  return (
    <div className="admin-tab-bar-container">
      { tabs.map((tab) => (
        <ButtonBase
          tagName="div"
          onClick={() => handleTabChange(tab)}
          key={uuid()}
        >
          <div
            className={`tab-container ${selectedTab === tab.split(' ').join('_').toLocaleLowerCase() && 'selected'}`}
          >
            <h3>
              {tab}
            </h3>
          </div>
        </ButtonBase>
      ))}
    </div>
  );
};
